/* eslint-disable id-match */
import {
	TOOLTIP_MSG_ID,
	TOOLTIP_MSG_CLASS,
	WIDGET_BUTTON_ID,
	WIDGET_BUTTON_CLASS,
	WIDGET_TOOLTIP_ID,
	WIDGET_TOOLTIP_CLASS,
} from '../job-chat-client/constants';

export const outerCSSString = (stylesObj) => `
	button#${WIDGET_BUTTON_ID}.${WIDGET_BUTTON_CLASS} {
    border-radius: 50%;
    background-color: ${stylesObj.widgetButtonBackgroundColor};
    color: ${stylesObj.widgetButtonFontColor};
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.14), 0 4px 5px 0 rgba(0, 0, 0, 0.12), 0 1px 10px rgba(0, 0, 0, 0.2);
    cursor: pointer;
    /* Position */
    position: fixed;
    z-index: 3999999;
    bottom: 20px;
    right: 20px;
    height: 44px;
    width: 44px;
    padding: 2px 6px 0px;    
    /* CSS Reset */
    margin: 0;
    border: none;
    outline: none;
    box-sizing: border-box;
    user-select: none;    
    /* Initial State */
  	display: none;
    opacity: 0;
    transform: translate3d(0, 15px, 0);
    transition: 0.2s opacity, 0.2s transform;
  }

  button#${WIDGET_BUTTON_ID}.${WIDGET_BUTTON_CLASS}:focus {
    box-shadow: ${stylesObj.tooltipBackgroundColor} 0px 0px 0px 5px inset;
  }

  button#${WIDGET_BUTTON_ID}.${WIDGET_BUTTON_CLASS}.left {
    left: 20px;
    right: auto;
  }

  div#${WIDGET_TOOLTIP_ID}.${WIDGET_TOOLTIP_CLASS} {
    position: fixed;
    z-index: 3999999;
    bottom: 21px;
    right: 80px;
    height: 40px;
    background-color: ${stylesObj.tooltipBackgroundColor};
    color: ${stylesObj.tooltipFontColor};
    box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.2), 0 1px 10px 0 rgba(0, 0, 0, 0.12), 0 4px 5px 0 rgba(0, 0, 0, 0.14);
    border-radius: 4px;
    max-width: 600px;
    padding: 20px;        
    /* CSS Reset */
    border: none;
    outline: none;
    margin: 0;
    box-sizing: border-box;
    user-select: none;    
    /* Initial State */
  	display: none;
    opacity: 0;
    transform: translate3d(-15px, 0, 0);
    transition: 0.5s opacity, 0.5s transform;
  }

  div#${WIDGET_TOOLTIP_ID}.${WIDGET_TOOLTIP_CLASS}.left {
    left: 80px;
    right: auto;
  }

  div#${WIDGET_TOOLTIP_ID}.${WIDGET_TOOLTIP_CLASS}:after, div#${WIDGET_TOOLTIP_ID}.${WIDGET_TOOLTIP_CLASS}:before {
    left: 100%;
    top: 50%;
    border: solid transparent;
    content: "";
    height: 0;
    width: 0;
    position: fixed;
    pointer-events: none;
  }

  div#${WIDGET_TOOLTIP_ID}.${WIDGET_TOOLTIP_CLASS}.left:after, div#${WIDGET_TOOLTIP_ID}.${WIDGET_TOOLTIP_CLASS}.left:before {
    right: 100%;
    left: auto;
    content: "";
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
    border-right: 10px solid ${stylesObj.tooltipBackgroundColor};
    border-left: 10px solid transparent;
    border-up: 10px solid transparent;
    border-down: 10px solid transparent;
  }

  div#${WIDGET_TOOLTIP_ID}.${WIDGET_TOOLTIP_CLASS}:after {
    border-color: rgba(31, 125, 132, 0);
    border-left-color: ${stylesObj.tooltipBackgroundColor};
    border-width: 10px;
    margin-top: -10px;
  }

  p#${TOOLTIP_MSG_ID}.${TOOLTIP_MSG_CLASS} {
    color: ${stylesObj.tooltipFontColor};
    font-size: 12px;
    line-height: 18px !important;
    height: 18px;
    font-family: Helvetica Neue !important;
    font-weight: 400 !important;
    letter-spacing: 0.5px;
    white-space: nowrap;
    overflow-x: hidden;
    text-overflow: ellipsis;    
    /* CSS Reset */
    margin: 0;
    padding: 0;
    border: none;
    outline: none;
    box-sizing: border-box;
    user-select: none;
		box-shadow: none;
	}
	
	button#${WIDGET_BUTTON_ID}.${WIDGET_BUTTON_CLASS}[data-badge]:after {
		content: attr(data-badge);
		position: absolute;
		top: -10px;
		right: -12px;
		font-size: 10px;
		background-color: ${stylesObj.notificationBackgroundColor};
		color: #FFFFFF;
		width: 18px;
		height: 18px;
		text-align: center;
		line-height: 18px;
		border-radius: 50%;
		box-shadow: 0 0 1px #333;
	}
  
  .acs-widget-message-indicator {
    position: fixed;
    z-index: 3999999;
    bottom: 66px;
    right: 10px;
    width: 14px;
    height: 20px;
    background-color: #cf0a2c;
    border-radius: 50%;
    padding: 2px 0 0 7px;
    /* CSS Reset */
   	margin: 0;
    border: none;
    outline: none;
   	box-sizing: border-box;
    user-select: none;
    box-shadow: none;
    /* Initial State */
    visibility: hidden;
  }

  .acs-message-indicator-text {
    display: inline;
    font-size: 14px;
    font-family: SourceSansPro;
    color: #ffffff;  
  }
  
  @keyframes tooltipDemo {
    0% {opacity: 1;  transform: translate3d(0,0,0);}
    70% {opacity: 1;  transform: translate3d(0,0,0);}
    75% {opacity: 0;  transform: translate3d(0,5px,0);}
    95% {opacity: 0;  transform: translate3d(-15px,0,0);}
    100% {opacity: 1;  transform: translate3d(0,0,0);}
  }`;
